import 'SF/dashboard/data/MyMessagesStore.js';
import 'SF/dashboard/student/MyMessagesPanel.js';
import 'SF/dashboard/MyMessagesDetailsWindow.js';
